import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { CopyBlock, dracula } from "react-code-blocks";



const JavaScriptLesson9 = () => {
  const [language, changeLanguage] = useState("javascript");
  const [lineNumbers, toggleLineNumbers] = useState(false);
  const code = (
  'text',
  `
  console.log(greeting); //undefined
  var greeting = "Hello World";
  `
  );
  const code2 = (
  'text',
  `
  var greeting;
  console.log(greeting); //undefined
  var greeting = "Hello World";
  `
  );
  const code3 = (
  'text',
  `
  console.log(greeting); //cannot access uninitialized variable
  let greeting = "Hello World";
  `
  );
  const code4 = (
  'text',
  `
  console.log(val); //cannot find variable val
  let greeting = "Hello World";
  `
  );
  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">

    <div className="alert alert-secondary" role="alert">
    <h3><strong>Variable hoisting</strong></h3>
            <p>During JavaScript code execution by the JavaScript engine, a global execution context is created. The global execution context has two phases: <strong><i>creation and execution.</i></strong>
              During the creation phase, the JavaScript engine moves the variable and function declarations to the top of your code. This behaviour is known as <strong>hoisting</strong>.
              </p>
              <p>In variable hoisting, the JavaScript engine moves the variable declarations to the top of the script as illustrated below.</p>
              <CopyBlock
              language={language}
              text={code}
              showLineNumbers={lineNumbers}
              theme={dracula}
              wrapLines={true}
              codeBlock
              />
              <p>Notice that we are printing the variable before declaration, and still we don't get an error. This is because the JavaScript engine moves the variable declaration to the top of the script.</p>
              <p class="mb-4">Technically, the code looks like the following in the execution phase:</p>
              <CopyBlock
              language={language}
              text={code2}
              showLineNumbers={lineNumbers}
              theme={dracula}
              wrapLines={true}
              codeBlock
              />
              </div>
            <div className="alert alert-secondary" role="alert">
               <h3><strong>Hoisting with the let keyword</strong></h3>
              <p class="mb-4">The following declares the variable <span class="font-weight-bold">counter</span> with the <strong>let</strong> keyword:</p>
              <CopyBlock
              language={language}
              text={code3}
              showLineNumbers={lineNumbers}
              theme={dracula}
              wrapLines={true}
              codeBlock
              />
              <p className="mt-3">The error message means that the <span class="font-weight-bold">greeting</span> variable is already in the heap memory. But, it hasn’t been initialized yet.
                Behind the scenes, the JavaScript engine hoists the variable declarations that use the <strong>let</strong> keyword. However, it doesn’t initialize the let variables.</p>
                <p>Now notice that if we try to access a variable that doesn’t exist, JavaScript will throw a different error</p>
                <CopyBlock
                language={language}
                text={code4}
                showLineNumbers={lineNumbers}
                theme={dracula}
                wrapLines={true}
                codeBlock
                />
            </div>
              <div className="alert alert-secondary" role="alert">
              <h3><strong>Untyped</strong></h3>
              <p>JavaScript is an untyped programming language. This means it can hold a value of any data type.</p>
              <p>Unlike many other programming languages, you don't have to tell JavaScript during variable declaration what type of value the variable should hold.
                The value of a variable can change during code execution and JavaScript takes care of it automatically.</p>
              </div>


    </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}

export default JavaScriptLesson9
